
import { defineComponent } from "vue";
 import ContactForm from "../components/ContactForm.vue";

export default defineComponent({
  components: {
     ContactForm,
  },
})
